
<template>
    <template v-if="viewData.config.settings?.target">
        <template v-if="(portalStore.company === undefined) && !isCompanyUndefinedAllowed"></template>
        <template v-else-if="viewData.config.settings?.target?.workflowcard_id || viewData.workflowcard_id">
            <div class="row tabrow" v-if="viewData.workflowcard_id">
                <div class="tabcolumn" :class="{ 'col-sm-9': viewData.visible.sidecolumn, 'col-sm-12': !viewData.visible.sidecolumn }">
                    <div class="inner Summary" :key="viewData.workflowboard_id" v-if="viewData.workflowboard_id && viewData.workflowcard_id && workflowlayout(viewData.workflowboard_id, 'detail')?.length">
                        <ul class="block-grid specs" cellspacing="0" cellpadding="0" border="0">
                            <template v-for="item in workflowlayout(viewData.workflowboard_id, 'detail')">
                                <li v-if="field(viewData.item.data, item.property.id, 'id')?.value || item.show_empty == 'Y' || (workflowlayout(viewData.workflowboard_id, 'detail')?.length === 1)" :set="property = field(viewData.item.data, item.property.id, 'id')" :class="{ spotlight: spotlight(item.property.id) }" @mouseover.prevent="handleTitle" :data-title="item.label">
                                    <label>{{ item.label }}</label>
                                    <var>
                                        <template v-if="resolvePropertyType(property) == 'MultiCardField'">
                                            <span v-for="(value, index) in property.value">
                                                <cardtitle v-if="value" :id="value" :key="value" /><span v-if="index < property.value.length - 1">, </span>
                                            </span>
                                        </template>
                                        <template v-else-if="resolvePropertyType(property) == 'CardField'">
                                            <cardtitle v-if="property.value" :id="property.value" :key="property.value" />
                                        </template>
                                        <template v-else-if="resolvePropertyType(property) == 'UserField'">
                                            <carduser v-if="property.value" :id="property.value" :key="property.value" />
                                        </template>
                                        <template v-else-if="resolvePropertyType(property) == 'CheckboxField'">
                                            {{ formatActives(property.value) }}
                                        </template>
                                        <template v-else>
                                            {{ formatValue(property) }}
                                        </template>
                                    </var>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <ul class="block-grid tabs" v-if="isTabNavigationVisible && (tab_navigation(tabs('maincolumn'), 'tabs').length > 1)">
                        <li v-for="tab in tab_navigation(tabs('maincolumn'), 'tabs')" :class="{ active: tab_active(tab.property.type, tab.property.id) }" @click.prevent="handleTabClick(tab.property.type, tab.property.id)">
                            <span class="title">{{ trans(overrule("tab", tab.label)) }}</span>
                        </li>
                    </ul>
                    <Teleport :to="'#navigationSpot'">
                        <nav v-if="tab_navigation(tabs('maincolumn'), 'top').length > 1">
                            <button type="button" class="more-icon bg" v-for="tab in tab_navigation(tabs('maincolumn'), 'top')" @click.prevent="handleTabClick(tab.property.type, tab.property.id)" :title='trans(overrule("tab", tab.label))'>
                                <Icon :name="tab.property.icon || 'list'" />
                            </button>
                        </nav>
                    </Teleport>
                    <tab-overview :tabs="tabs('maincolumn')" :hide_heading="true" />
                    <div id="top" v-if="!viewData.visible.sidecolumn"></div>
                </div>
                <div class="col-sm-3 sidecolumn">
                    <div class="inner"><Actions :wrapper="false" :classlist="{ inner: false }" v-if="isButtonsVisible && (isCompanyUndefinedAllowed || company) && viewData.workflowcard_id" :key="viewData.workflowphase_id" /></div>
                    <div id="top"></div>
                    <tab-overview :tabs="tabs('sidecolumn')" :always_open="true" />
                </div>
            </div>
            <div v-else class="error">
                {{ trans("Het lijkt erop dat het betreffende item niet (meer) te bereiken is.")}}<br>
                {{ trans("Mocht dit probleem aanhouden, neem dan contact op met de beheerder.") }}
            </div>

        </template>
        <template v-else-if="viewData.workflowphase_id">
            <workflowphase-list
                :workflowboard_id="viewData.workflowboard_id"
                :workflowphase_id="viewData.workflowphase_id"
                :related_filter_json="viewData.extra_filters"
                :key="viewData.overview_ticker"
            ></workflowphase-list>
        </template>
        <template v-else>
            <workflowphase-overview
                v-if="viewData.workflowboard_id"
                :layout="viewData.layout"
                :workflowboard_id="viewData.workflowboard_id"
                :workflowphase_id="viewData.workflowphase_id"
                :related_filter_json="viewData.extra_filters"
                :key="viewData.overview_ticker"
            ></workflowphase-overview>
        </template>
    </template>
    <template v-else>
        {{ route.meta.module }} {{ route.meta.action }}<br>
        {{ viewData.type }}<br>
    </template>
</template>

<script>
import {computed, defineComponent, inject} from "vue";
import { useRoute } from "vue-router";

import tabOverview from "view/dashboard/includes/tab-overview";

import { portalStore, isCompanyUndefinedAllowed } from "store/portal";
import { company } from "store/company";
import { workflowproperties, workflowpropertiesbyfieldgroup } from "store/workflow";

import Icon from "components/icon";
import trans from "helpers/_translation";
import { formatActives, formatValue } from "helpers/_formatting";

import workflowphaseList from "view/dashboard/includes/workflowphase-list";
import workflowphaseOverview from "view/dashboard/includes/workflowphase-overview";

import cardtitle from "components/workflowcard/cardtitle";
import carduser from "components/workflowcard/carduser";

import { workflowlayout, resolvePropertyType } from "store/workflow";
import { field } from "store/portal";

import Actions from "components/workflowcard/actions";

export default defineComponent({
    name: "part",
    components: {
        Icon,
        Actions,

        tabOverview,

        workflowphaseList,
        workflowphaseOverview,

        cardtitle,
        carduser
    },
    setup() {
        const route = useRoute();
        const viewData = inject("viewData");

        const handleTabClick = inject("handleTabClick");
        const tabs = inject("tabs");
        const tab_editable = inject("tab_editable");
        const tab_active = inject("tab_active");

        const overrule = inject("overrule");

        const tab_navigation = (data, position) => {
            const topMap = ["files", "reactions", "historylog"];
            return data.filter(tab => {
                if (position == "tabs") {
                    return !topMap.includes(tab.property.id);
                } else if (position == "top") {
                    return topMap.includes(tab.property.id);
                }
                return false;
            });
        };

        const isTabNavigationVisible = computed(() => {
            if (viewData.config?.settings?.disabled?.tab_navigation) {
                return false;
            }
            return !!viewData.workflowcard_id;
        });
        const isButtonsVisible = inject("isButtonsVisible");

        const spotlight = (property_id) => {
            return computed(() => {
                console.log("property_id",property_id, viewData.config?.settings);
                const ids = (viewData.config?.settings?.summary?.spotlight ?? []).map(a => `${a}`);
                return ids.includes(`${property_id}`);
            }).value;
        }

        const handleTitle = (e) => {
            const target = e.currentTarget || e.target;

            let title = `${target.dataset.title}: `;
            const variable = target.querySelector("var");
            if (variable) {
                title += variable.innerText;
            }
            target.setAttribute("title", title);
        };

        return {
            trans,
            route,

            company,
            portalStore,

            formatActives,
            formatValue,

            viewData,
            workflowproperties,
            workflowpropertiesbyfieldgroup,

            tabs,
            tab_active,
            tab_editable,
            handleTabClick,

            overrule,

            isButtonsVisible,
            isTabNavigationVisible,
            isCompanyUndefinedAllowed,

            workflowlayout,
            resolvePropertyType,
            field,

            spotlight,

            handleTitle,

            tab_navigation
        }
    }
});
</script>